module.exports = {
  email: "karthikajar555@gmail.com",

  socialMedia: {
    linkedin: {
      url: "https://www.linkedin.com/in/karthiik",
      name: "Linkedin",
    },
    github: {
      url: "https://github.com/karthik-raja-g",
      name: "Github",
    },
    medium: {
      url: "https://karthikraja555.medium.com",
      name: "Medium"
    }
  },

  navLinks: [
    {
      name: "About",
      url: "/#about",
    },
    {
      name: "Skills",
      url: "/#skills",
    },
    {
      name: "Projects",
      url: "/#projects",
    },
    {
      name: "Get in touch",
      url: "/#get-in-touch",
    },
  ]
};
